import { render, staticRenderFns } from "./products.vue?vue&type=template&id=16c7bdcc&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ILogoWordFlat: require('/opt/build/repo/components/svg/LogoWordFlat.vue').default,CategoryGrid: require('/opt/build/repo/components/CategoryGrid.vue').default,ProductGrid: require('/opt/build/repo/components/ProductGrid.vue').default})
